import katex from "katex";
import { WidgetType } from "@uiw/react-codemirror";
import "katex/dist/katex.min.css";
export class MarkdownMathWidget extends WidgetType {
    constructor(config) {
        super();
        this.config = config;
    }
    eq(widget) {
        return widget.config.source === this.config.source
            && widget.config.displayMode === this.config.displayMode
            && widget.config.sourceFrom === this.config.sourceFrom;
    }
    toDOM(view) {
        const element = document.createElement("span");
        element.className = this.config.displayMode
            ? "cm-markdown-math-widget cm-markdown-math-widget-block"
            : "cm-markdown-math-widget cm-markdown-math-widget-inline";
        try {
            katex.render(this.config.source, element, {
                displayMode: this.config.displayMode,
                throwOnError: true,
                trust: false
            });
        }
        catch (error) {
            element.classList.add("cm-markdown-math-widget-error");
            element.textContent = this.config.rawSource;
            element.title = error instanceof Error ? error.message : "Invalid formula";
        }
        element.addEventListener("mousedown", (event) => {
            event.preventDefault();
            view.dispatch({
                selection: { anchor: this.config.sourceFrom },
                scrollIntoView: true
            });
            view.focus();
        });
        return element;
    }
    ignoreEvent() {
        return true;
    }
}
